import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-doconline-close",
  "use": "icon-doconline-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-doconline-close\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 11.2929L15.6465 7.64645L16.3536 8.35355L12.7071 12L16.3536 15.6464L15.6465 16.3536L12 12.7071L8.35359 16.3536L7.64648 15.6464L11.2929 12L7.64648 8.35355L8.35359 7.64645L12 11.2929Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol